module.exports = __webpack_public_path__ + "def3a6daf675cda795319efce4392af1.mp3";